export const projectScheduleImportTranslationsEn = {
  fakes: {
    importProgressStep1: 'File is being read...',
    importProgressStep2: 'Phases and domains are being identified...',
    importProgressStep3: 'Construction site setup is being generated...',
    importProgressStep4: 'Shell construction is being generated...',
    importProgressStep5: 'Building envelope is being generated...',
    importProgressStep6: 'Fitout is being generated...',
    importProgressStep7: 'Other is being generated...',
    importProgressStep8: 'Milestones are being assigned...',
    importProgressStep9: 'Dependencies are being added...',
    importProgressStep10: 'Import is being completed...',
  },
  helpLink: 'Learn more about the import',
  importFailed: 'Schedule import failed',
  importInProgress: 'Schedule import in progress...',
  importSuccess: 'Schedule import successful',
  importSuccessDescription: 'Please refresh the page to get started!',
  onboardingStepperDescription: 'Upload your existing schedule',
  onboardingStepperTitle: 'Import project',
  selectPlan: 'Select plan',
  sidebarTitle: 'Schedule imported',
  sidebarSubtitle: 'on {date} by {user} from the file {file} in {time}',
  sidebarHighlightsTitle: 'Highlights',
  sidebarHighlightsStructure:
    'Your schedule consists of {n} fewer lines compared to the original and is therefore more concise',
  sidebarHighlightsTrades: '1 trade was found and assigned | {n} trades were found and assigned',
  sidebarHighlightsCollisions:
    'We checked your original .mpp schedule and found {n} collisions | We found {n} collision in your original .mpp schedule - check and fix this to improve your schedule! | We found {n} collisions in your original .mpp schedule - check and fix this to improve your schedule!',
  sidebarHighlightsCollisionsPartialTextNoCollsions: 'zero',
  sidebarDataTitle: 'Data',
  startImport: 'Import schedule',
  // summary card
  summaryCalendarsSuccess: 'All work schedules were successfully imported',
  summaryCalendarsTitle: 'Work schedules',
  summaryCalendarsIssueInvalidHeadline:
    '1 work schedule could not be imported | {n} work schedules could not be imported',
  summaryDependenciesSuccess: 'All dependencies were successfully imported',
  summaryDependenciesTitle: 'Dependencies',
  summaryDependenciesIssueInvalidHeadline:
    '1 dependency could not be imported | {n} dependencies could not be imported',
  summaryDependenciesIssueInvalidReasonInvalidConnector: 'Connector could not be found',
  summaryDependenciesIssueInvalidReasonDuplicate: 'Dependency exists multiple times',
  summaryDependenciesIssueInvalidReasonNonLeafConnector: 'Dependency between summary section',
  summaryDependenciesIssueInvalidReasonCyclic: 'Cyclic dependency found',
  summaryDependenciesIssueCollisionsHeadline:
    '1 new collision appeared | {n} new collisions appeared',
  summaryDependenciesIssueCollisionsReasonHourly: 'Transformation of hourly dates',
  summaryDependenciesIssueCollisionsHintHourly:
    'Usually, activities are planned in MS-Project with hourly times. In contrast, activities in koppla are only set on a daily basis. When transforming hourly times into daily times during the import, new collisions can occur.',
  summaryIssueGenericReason: 'Unknown error during import',
  summaryMilestonesSuccess: 'All milestones were successfully imported',
  summaryMilestonesTitle: 'Milestones',
  summaryMilestonesHint: 'Hint: You can search for milestones with {shortcut}',
  summaryMilestonesIssueInvalidHeadline:
    '1 milestone could not be imported | {n} milestones could not be imported',
  summaryMilestonesIssueInvalidReasonInvalidTrade: 'Trade could not be assigned',
  summaryMilestonesIssueInvalidReasonInvalidDate: 'Invalid date found',
  summaryMilestonesIssueInvalidReasonInvalidParent: 'Section could not be assigned',
  summaryOrdersSuccess: 'All activities were successfully imported',
  summaryOrdersTitle: 'Activities',
  summaryOrdersHint: 'Hint: You can search for activities with {shortcut}',
  summaryOrdersIssueInvalidHeadline:
    '1 activity could not be imported | {n} activities could not be imported',
  summaryOrdersIssueInvalidReasonInvalidTrade: 'Trade could not be assigned',
  summaryOrdersIssueInvalidReasonInvalidDateRange: 'Invalid start or end date found',
  summaryOrdersIssueInvalidReasonInvalidParent: 'Section could not be assigned',
  summaryOrdersIssueInvalidReasonInvalidCalendar: 'Work schedule could not be assigned',
  summaryTimeRangeSuccess: 'The total time range was successfully imported',
  summaryTimeRangeError: 'The total time range could not be correctly imported',
  summaryTimeRangeErrorExpectedPrefix: 'Original: ',
  summaryTimeRangeErrorActualPrefix: 'Imported: ',
  summaryTimeRangeErrorReason: 'Some activity dates could not be correctly imported',
  summaryTimeRangeTitle: 'Time range',
};
